import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, {Component} from "react";

class AlertDialog extends Component {

    clickedPositive = () => {
        this.props.action(true);
    };

    clickedNegative = () => {
        this.props.action(false);
    };

    size = () => {
        return this.props.size || "sm";
    };

    render() {
        return (
            <div>
                <Dialog open={this.props.open} fullWidth={true} maxWidth={this.size()}>
                    <DialogTitle>{this.props.title}</DialogTitle>
                    <DialogContent>
                        {this.props.content && this.props.content()}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.clickedNegative} color="primary">
                            {this.props.negative}
                        </Button>
                        <Button onClick={this.clickedPositive} color="primary" autoFocus>
                            {this.props.positive}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

}


export default AlertDialog;